import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAgile from 'vue-agile'

// custom scroll
import ScrollAnimation from './directives/scrollanimate'
Vue.directive('scrollanimate', ScrollAnimation)

// carousel
Vue.use(VueAgile)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
